import { FlatList, SafeAreaView, View } from 'react-native';
import { ModernHeader } from '~components/ModernHeader';
import PersonItem from '~components/Matching/PersonItem';
import { useGetMatches } from '~hooks/event/useGetMatches';
import { useMatchingLoaderAnimationStore } from '~providers/matching/zustand';
import getStyles from './styles';
import { useEffect } from 'react';
import { logScreenView } from '~Utils/firebaseAnalytics';
import { useRoute } from '@react-navigation/native';
import { useGetUserAccount } from '~hooks/user/useGetUser';
import { useUserStore } from '~providers/userStore/zustand';
import { User } from '~types/api/user';
import Button from '~components/Button';
import { t } from 'i18next';
import { useTheme } from '~contexts/ThemeContext';
import ModernEventCard from '~components/HomeScreenComponent/tabComponents/components/ModernEventCard/ModernEventCard';

const MatchingUsersScreen = () => {
  const { colors } = useTheme();
  const styles = getStyles(colors);
  const { matchingEventId, domain, refresh, setRefresh, matchingType } = useMatchingLoaderAnimationStore();

  const { data, refetch } = useGetMatches(matchingEventId, refresh, domain, matchingType);
  const route: any = useRoute();
  const user = useUserStore(state => state.user);
  const { data: userAccount } = useGetUserAccount(user?.uid);
  // Extract event and domain from route parameters
  const { event } = route.params;

  useEffect(() => {
    logScreenView('Matching Users', 'MatchingUsersScreen');
    console.log('Domain:', domain); // Log the domain for debugging
  }, [domain]);

  const refreshAttendees = () => {
    setRefresh(true); // Toggle refresh to a new value
    setTimeout(() => {
      refetch();
    }, 300);
  };

  return (
    <SafeAreaView style={{ flex: 1 }}>
      <ModernHeader title="Find People to Go With" subtitle={event?.name} variant="elevated" />

      {event && <FlatList
        data={data}
        style={styles.container}
        contentContainerStyle={styles.padding}
        keyExtractor={item => `${item.uid}=match`}
        ListHeaderComponent={() => (
          <View style={styles.eventTileContainer}>
            <ModernEventCard item={event} index={0} disableAnimation={true} />
          </View>
        )}
        renderItem={({ item, index: i }) => (
          <PersonItem person={item} i={i} event={event} userAccount={userAccount as User} />
        )}
      />}

      {refresh && <Button
        label={t('events.refresh')}
        containerStyle={{ backgroundColor: colors.primary, width: '90%', alignSelf: 'center', marginBottom: 10 }}
        textStyle={{ fontSize: 16, fontWeight: '600', color: colors.white }}
        onPress={refreshAttendees}
      />}
    </SafeAreaView>
  );
};

export default MatchingUsersScreen;
